import { toast } from "react-toastify";

export function ToastWarn(message) {
    // return (
    toast.warn(
        <div className="flex justify-between items-center">
            <p>{message}</p>
        </div>
        // , { position: "bottom-center", }
    );
    // )
}

export function ToastSuccess(message, cancel, cancel_call_back) {
    toast.success(
        <div className="flex justify-between items-center">
            <p>{message}</p>
            {cancel &&
                <button
                    className="bg-mainGreen py-[5px] px-[10px] text-sm text-white rounded-lg"
                    onClick={() => {
                        cancel_call_back()
                    }}
                >
                    Annuler
                </button>
            }
        </div>
    );
}